import React, { useRef, useState } from "react";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { selectAdminToken } from "../../sessionSlice";
import { uploadSpaceGameQuestionsCSV } from "../../functions/uploadSpaceGameQuestionsCSV";
import "../uploadCSV/uploadCSV.css";

export default function SpaceGameCsvUploadModal({ isOpen, onClose, onUploaded }) {
  const fileInputRef = useRef(null);
  const [csvFile, setCsvFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const adminToken = useSelector(selectAdminToken);

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== "text/csv" && !file.name.endsWith(".csv")) {
      Swal.fire("Invalid File", "Please select a CSV file.", "error");
      e.target.value = null;
      setCsvFile(null);
      return;
    }
    setCsvFile(file);
  };

  const handleUpload = async () => {
    if (!csvFile) {
      return Swal.fire("No File", "Please choose a CSV file first.", "warning");
    }

    setIsUploading(true);
    try {
      const data = await uploadSpaceGameQuestionsCSV({ file: csvFile, token: adminToken });
      Swal.fire("Success", data.message || "CSV imported successfully.", "success");
      setCsvFile(null);
      if (fileInputRef.current) fileInputRef.current.value = null;
      onUploaded();
    } catch (err) {
      Swal.fire("Failed to save CSV", err.message || "Failed to upload CSV.", "info");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      <div className="modal-backdrop" onClick={onClose} />
      <div className="csv-modal">
        <h3>Upload Questions CSV</h3>
        <div className="csv-form-group">
          <button className="csv-file-btn" onClick={() => fileInputRef.current.click()}>
            Choose CSV File
          </button>
          <span className="csv-file-name">{csvFile?.name || "No file selected"}</span>
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            className="csv-file-input"
            onChange={handleFileChange}
          />
        </div>
        <div className="code">
          * Columns: question_text, option_a, option_b, option_c, option_d, correct_answer, timer_seconds, points
          <br />
          * correct_answer defaults to C, timer_seconds to 30, points to 10 if left blank.
          <br />
          * Maximum 30 rows. Uploading replaces all existing questions for this session.
          <br />
          <a href={`${process.env.PUBLIC_URL}/spacegameQuestionsSample.csv`} download>
            Download sample CSV
          </a>
        </div>
        <div className="csv-actions">
          <button className="csv-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="csv-upload-btn" onClick={handleUpload} disabled={isUploading}>
            {isUploading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>
    </>
  );
}
